/* Usage:
What it does:
Adds autocomplete functionality to user searches in the Library. Gives the user prefix and category to an Autocomplete API that will return suggestions.
Usage:
Called in CatalogNew.cshtml, but affects the elements in SearchBar.cshtml.
*/

import Roblox from 'Roblox';
import '../../css/libraryAutocomplete/libraryAutocomplete.css';
import libraryAutocomplete from './libs/libraryAutocomplete.js';

Roblox.require(['Pages.Catalog', 'Pages.CatalogShared'], function (catalog) {
  const { autocompleteEndpoint, autocompleteLimit, autocompleteShouldShow } =
    Roblox.LibraryAutocompleteParameters || {};
  if (autocompleteShouldShow) {
    if (!autocompleteEndpoint) {
      console.error('Autocomplete API endpoint is empty, autocomplete cannot be set up');
      return;
    }

    const keywordTextboxElement = document.getElementById('keywordTextbox');
    const categoryKeywordElement = document.getElementById('categoriesForKeyword');
    libraryAutocomplete(
      keywordTextboxElement,
      categoryKeywordElement,
      autocompleteEndpoint,
      autocompleteLimit,
      catalog.SearchOnKeyword
    );
  }
});
